import { RootState } from '../store';

export const selectShowStateModal = (state: RootState): boolean => state.location.showStateModal;
